import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { useEffect, useState } from 'react'

import { mixOther } from 'api/mixOther'

type Item = {
    id: string;
    name: string;
    namecustomer: string;
    address: string;
    feedback: string;
    image: string;
};

type About = {
    meta_title: string;
    meta_description: string;
    meta_keywords: string;
    list_feedback: Item[];
}

export default function YKienKhachHang() {
    const [about, setAbout] = useState<About | null>(null)

    useEffect(() => {
        const loadOther = async () => {
            const res = await mixOther("sshome", "vi")
            if (!res?.status || !res.data?.json) {
                return;
            }

            try {
                const parsed = JSON.parse(res.data.json);
                setAbout((prev) => ({ ...prev, ...parsed }));
            } catch (error) {
                console.error("Failed to parse setting JSON:", error);
            }
        };

        loadOther();
    }, [])

    // useEffect(()=> {
    //     console.log(about)
    // },[about])

    return (
        <div className="mt-10 mb-6">
            <div className="MuiContainer-root MuiContainer-maxWidthLg md:!pl-0 md:!pr-0">

                {/* Title */}
                <div className="styles_companyIntroduction__h04I7">
                    <div className="styles_title__JlrYL">
                        <div className="styles_companyTitle__W3WKs">
                            Khách hàng nói gì về{" "}
                            <span className="styles_branchName__QPk2S">Tâm Hạnh</span>
                        </div>

                        <svg
                            className="styles_vector__ifrV4"
                            width="202"
                            viewBox="0 0 200 4"
                            fill="none"
                        >
                            <path
                                d="M0 2H200"
                                stroke="#005C29"
                                strokeWidth="4"
                                strokeLinecap="round"
                            />
                        </svg>
                    </div>
                </div>

                {/* Slider */}
                <Swiper
                    modules={[Autoplay, Navigation]}
                    spaceBetween={30}
                    slidesPerView={3}
                    autoplay={{ delay: 511000 }}
                    loop
                    className="mt-6"
                    breakpoints={{
                        0: {
                            slidesPerView: 1,
                        },
                        640: {
                            slidesPerView: 2,
                        },
                        768: {
                            slidesPerView: 2,
                        },
                        1024: {
                            slidesPerView: 3,
                        },
                    }}
                >
                    {about?.list_feedback && about?.list_feedback?.length > 0 && about?.list_feedback.map((item, index) => {
                        const isEven = index % 2 === 0;

                        return (
                            <SwiperSlide key={item.id}>
                                <div className="flex justify-center">
                                    <div className="flex flex-col items-center text-center max-w-[520px] w-full bg-[#f5f5f5] rounded-[20px] shadow-sm p-5">

                                        {/* Avatar */}
                                        <div className="w-[233px] h-[233px] rounded-full overflow-hidden mb-6">
                                            <img
                                                src={item.image}
                                                alt={item.name}
                                                className="w-full h-full object-cover"
                                            />
                                        </div>

                                        {/* Feedback */}
                                        <p className="text-[16px] italic text-[#2e7d32] leading-7 max-w-[420px]">
                                            “{item.feedback}”
                                        </p>

                                        {/* Info */}
                                        <div>
                                            <p className="font-semibold text-[#2e7d32] text-[16px] !mb-0">
                                                {item.namecustomer}
                                            </p>

                                            <p className="text-sm text-gray-500 !mb-0 mt-2">
                                                {item.address}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </div>
        </div>
    );
}